// Common
import { ComponentRef, Directive, Input } from '@angular/core';

// Directives
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';

// Components
import { SidebarContextMenuComponent } from '@modules/messages/components/sidebar-context-menu/sidebar-context-menu.component';
import { type RailScope } from '@modules/common/components/rail-menu/rail-menu';

// Types
import { VirtualFolder } from '@modules/messages/types/virtual-folder';

@Directive({
  selector: '[appSidebarContextMenu]',
  standalone: false,
})
export class SidebarContextMenuDirective extends ContextMenuDirective {
  // Inputs
  @Input() appSidebarContextMenu: VirtualFolder;
  /**
   * The mailbox the CLICKED ROW belongs to, which is not the mailbox the app is on.
   *
   * Without it the menu's `Add New Folder` quick form fell through to `effectiveTenantId()`: right-
   * clicking the TEAM `Folders` row while the app was on the member mailbox created the folder in the
   * MEMBER mailbox (#1075, measured on the site). Same binding added to notes' section menu on
   * #1068 — the row's owner decides, never the rail's selection.
   */
  @Input() appSidebarContextMenuTenantId: string | null | undefined;

  /** A My or Team Workspace row: draws the shared rail menu (`mail-rail-menu.ts`) instead of the old one. */
  @Input() appSidebarContextMenuRail = false;
  /** Whose row this is; a team row acts on shared team mail. */
  @Input() appSidebarContextMenuRailScope: RailScope = 'mine';
  /** Shows another view of the row's mailbox, for "Open Other Mail". */
  @Input() appSidebarContextMenuOpenView: ((filter: VirtualFolder) => void) | undefined;

  registerComponent() {
    return SidebarContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<SidebarContextMenuComponent>) {
    componentRef.instance.sidebarFilterKey = this.appSidebarContextMenu;
    componentRef.instance.railOrigin = this.elementRef.nativeElement;
    componentRef.instance.tenantId = this.appSidebarContextMenuTenantId;
    componentRef.instance.rail = this.appSidebarContextMenuRail;
    componentRef.instance.railScope = this.appSidebarContextMenuRailScope;
    componentRef.instance.openView = this.appSidebarContextMenuOpenView;
  }
}
